import { IconSun, IconMoon, IconSpark } from './icons';


export default function Features() {
  return (
    <section className="features" id="features">
      <div className="bento-features">
        {/* Heading cell */}
        <div className="bf-heading">
          <div className="kicker">
            <span className="kicker-dot" />
            <span>Everything in the box</span>
          </div>
          <h2 className="display features-title">
            Built like
            <br />a <em>kitchen.</em>
            <br />
            Runs like
            <br />
            <em>software.</em>
          </h2>
        </div>

        {/* Orders — showcase w/ live kanban */}
        <article className="bf bf-orders reveal-tile" style={{ '--d': '0ms' }}>
          <div className="bf-top">
            <div className="bf-tag bf-tag-lime">
              <span className="tag-dot" />
              F.01 · Order intake
            </div>
            <h4 className="display">
              No ticket
              <br />
              left <em>behind.</em>
            </h4>
            <p>
              Sub-second flow from a guest's tap to the kitchen line. No polling,
              no refresh, no misses.
            </p>
          </div>
          <div className="viz-kanban" aria-hidden="true">
            <div className="kb-col">
              <span className="kb-h">New</span>
            </div>
            <div className="kb-col">
              <span className="kb-h">Active</span>
            </div>
            <div className="kb-col">
              <span className="kb-h">Done</span>
            </div>
            <div className="kb-ticket">
              <span />
              <span />
            </div>
          </div>
        </article>

        {/* AI optimizer — showcase w/ equalizer */}
        <article className="bf bf-ai reveal-tile" style={{ '--d': '80ms' }}>
          <div className="bf-top">
            <div className="bf-tag bf-tag-lime">
              <span className="tag-dot" />
              F.02 · AI optimizer
            </div>
            <h4 className="display">
              A menu that
              <br />
              <em>learns.</em>
            </h4>
            <p>
              Surfaces the items quietly losing money and the ones quietly
              winning — and acts on your nod.
            </p>
          </div>
          <div className="viz-eq" aria-hidden="true">
            <span className="eq-spark"><IconSpark /></span>
            {[1, 2, 3, 4, 5, 6, 7].map((b) => (
              <i style={{ '--b': b }} key={b} />
            ))}
          </div>
        </article>

        {/* Live tracking — stepper */}
        <article className="bf bf-track reveal-tile" style={{ '--d': '160ms' }}>
          <div className="bf-tag bf-tag-lime">
            <span className="tag-dot" />
            F.03 · Live tracking
          </div>
          <h4 className="display">
            Watch it <em>cook.</em>
          </h4>
          <div className="viz-steps" aria-hidden="true">
            <div className="vs-line">
              <div className="vs-fill" />
            </div>
            <div className="vs-nodes">
              <span data-l="Placed" />
              <span data-l="Fired" />
              <span data-l="Plated" />
              <span data-l="Served" />
            </div>
          </div>
        </article>

        {/* Analytics — donut */}
        <article className="bf bf-analytics reveal-tile" style={{ '--d': '240ms' }}>
          <div className="bf-tag bf-tag-lime">
            <span className="tag-dot" />
            F.04 · Analytics
          </div>
          <div className="bf-analytics-row">
            <h4 className="display">
              Numbers,
              <br />
              <em>alive.</em>
            </h4>
            <div className="viz-donut" aria-hidden="true">
              <span className="vd-num">+68%</span>
            </div>
          </div>
        </article>

        {/* Dynamic menus — day/night */}
        <article className="bf bf-dynamic reveal-tile" style={{ '--d': '320ms' }}>
          <div className="bf-tag bf-tag-lime">
            <span className="tag-dot" />
            F.05 · Dynamic menus
          </div>
          <h4 className="display">
            Reads the <em>room.</em>
          </h4>
          <div className="viz-clock" aria-hidden="true">
            <span className="vc-sky" />
            <span className="vc-sun"><IconSun /></span>
            <span className="vc-moon"><IconMoon /></span>
            <span className="vc-label">Brunch → Dinner → Late</span>
          </div>
        </article>

        {/* Multi-location — dots lighting up */}
        <article className="bf bf-sm reveal-tile" style={{ '--d': '380ms' }}>
          <div className="bf-tag bf-tag-lime"><span className="tag-dot" />F.06</div>
          <div className="bf-sm-body">
            <span className="bf-emoji" aria-hidden="true">
              <span className="viz-ml">
                {[0,1,2,3].map(i => <span key={i} className="vml-dot" style={{'--i': i}} />)}
              </span>
            </span>
            <div className="bf-meta"><h4>Multi-location</h4><p>Two units or two hundred — one console.</p></div>
          </div>
        </article>

        {/* AI picks — rising bar highlight */}
        <article className="bf bf-sm reveal-tile" style={{ '--d': '440ms' }}>
          <div className="bf-tag bf-tag-lime"><span className="tag-dot" />F.07</div>
          <div className="bf-sm-body">
            <span className="bf-emoji" aria-hidden="true">
              <span className="viz-aip">
                {[0,1,2].map(i => <span key={i} className="vaip-bar" style={{'--i': i}} />)}
              </span>
            </span>
            <div className="bf-meta"><h4>AI picks</h4><p>Quiet, in-context upsell. Never spammy.</p></div>
          </div>
        </article>

        {/* Group ordering — circles converging */}
        <article className="bf bf-sm reveal-tile" style={{ '--d': '500ms' }}>
          <div className="bf-tag bf-tag-lime"><span className="tag-dot" />F.08</div>
          <div className="bf-sm-body">
            <span className="bf-emoji" aria-hidden="true">
              <span className="viz-grp">
                {[0,1,2].map(i => <span key={i} className="vgrp-dot" style={{'--i': i}} />)}
              </span>
            </span>
            <div className="bf-meta"><h4>Group ordering</h4><p>One table, one shared cart, split or unified.</p></div>
          </div>
        </article>

        {/* Configurator — sliding knob */}
        <article className="bf bf-sm reveal-tile" style={{ '--d': '560ms' }}>
          <div className="bf-tag bf-tag-lime"><span className="tag-dot" />F.09</div>
          <div className="bf-sm-body">
            <span className="bf-emoji" aria-hidden="true">
              <span className="viz-cfg">
                <span className="vcfg-track"><span className="vcfg-knob" /></span>
                <span className="vcfg-track vcfg-track-2"><span className="vcfg-knob vcfg-knob-2" /></span>
              </span>
            </span>
            <div className="bf-meta"><h4>Configurator</h4><p>Mods, sizes, proteins — pricing baked in.</p></div>
          </div>
        </article>

        {/* Order batching — append item to placed order */}
        <article className="bf bf-half reveal-tile" style={{ '--d': '620ms' }}>
          <div className="bf-tag bf-tag-lime">
            <span className="tag-dot" />
            F.10 · Order batching
          </div>
          <h4 className="display">Already ordered? <em>Add more.</em></h4>
          <p>Guests can keep adding items to their order even after it's been placed — no new ticket, no kitchen confusion.</p>
          <div className="viz-batch" aria-hidden="true">
            <div className="vb-row vb-placed"><span /><span /></div>
            <div className="vb-row vb-placed"><span /><span /></div>
            <div className="vb-row vb-placed"><span /><span /></div>
            <div className="vb-row vb-new"><span className="vb-plus">+</span><span /><span /></div>
          </div>
        </article>

        {/* Campaigns — peeling coupon reveals the discount, schedule strip below */}
        <article className="bf bf-half reveal-tile" style={{ '--d': '680ms' }}>
          <div className="bf-tag bf-tag-lime">
            <span className="tag-dot" />
            F.11 · Campaigns
          </div>
          <h4 className="display">Run the <em>promo.</em></h4>
          <p>Discount one item, one menu, or everything you sell — scheduled by exact date and time, fully configurable, running itself while you cook.</p>
          <div className="viz-campaign" aria-hidden="true">
            <div className="vcp-coupon">
              <div className="vcp-coupon-label">
                <span className="vcp-coupon-kicker">Campaign scope</span>
                <span className="vcp-coupon-scope">
                  <span className="vcp-word vcp-word-item">One item</span>
                  <span className="vcp-word vcp-word-menu">One menu</span>
                  <span className="vcp-word vcp-word-all">All menus</span>
                </span>
              </div>
              <div className="vcp-coupon-price">
                <div className="vcp-coupon-under">
                  <b>Rs 680</b>
                  <span>-20% OFF</span>
                </div>
                <div className="vcp-coupon-flap">Rs 850</div>
              </div>
            </div>
            <div className="vcp-schedule">
              <span className="vcp-schedule-caption">
                <span className="vcp-time-word vcp-time-weekdays">Weekdays · 11 AM–2 PM</span>
                <span className="vcp-time-word vcp-time-weekends">Weekends · 5–9 PM</span>
                <span className="vcp-time-word vcp-time-everyday">Every day · all hours</span>
              </span>
              <div className="vcp-week">
                <span className="vcp-week-glider" />
                {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((d, i) => (
                  <span key={i} className="vcp-week-day">{d}</span>
                ))}
              </div>
            </div>
          </div>
        </article>

        {/* QR — visual */}
        <article className="bf bf-qr reveal-tile" style={{ '--d': '740ms' }}>
          <div className="bf-qr-text">
            <div className="bf-tag bf-tag-lime">
              <span className="tag-dot" />
              F.12 · QR mapping
            </div>
            <h4 className="display">
              Every spot,
              <br />a <em>code.</em>
            </h4>
          </div>
          <div className="viz-qr" aria-hidden="true" />
        </article>

        {/* Role-based access — role badges cycling */}
        <article className="bf bf-sm bf-wide reveal-tile" style={{ '--d': '780ms' }}>
          <div className="bf-tag bf-tag-lime"><span className="tag-dot" />F.13</div>
          <div className="bf-sm-body">
            <span className="bf-emoji" aria-hidden="true">
              <span className="viz-rbac">
                {['ADM','KIT','FLR'].map((l, i) => (
                  <span key={l} className="vrbac-badge" style={{'--i': i}}>{l}</span>
                ))}
              </span>
            </span>
            <div className="bf-meta"><h4>Role-based access</h4><p>Branch admin, kitchen, floor — each sees only what they need.</p></div>
          </div>
        </article>

        {/* Audit trail — rows ticking off */}
        <article className="bf bf-sm bf-wide reveal-tile" style={{ '--d': '840ms' }}>
          <div className="bf-tag bf-tag-lime"><span className="tag-dot" />F.14</div>
          <div className="bf-sm-body">
            <span className="bf-emoji" aria-hidden="true">
              <span className="viz-audit">
                {[0,1,2].map(i => (
                  <span key={i} className="vaudit-row" style={{'--i': i}}>
                    <span className="vaudit-check" />
                    <span className="vaudit-line" />
                  </span>
                ))}
              </span>
            </span>
            <div className="bf-meta"><h4>Audit trail</h4><p>Every privileged action logged, attributed, reversible.</p></div>
          </div>
        </article>
      </div>
    </section>
  );
}
